import { Instalation } from "./Instalation";

export class Company {
    name: string;
    email: string;
    address: string;
    city: string;
    postal_code: string;
    country: string;
    type: number;
    active: boolean;
    licence: string;
    idcompany: number;
    instalations: Instalation[];
    image: string

    constructor() {
        // Asigna valores por defecto a las propiedades
        this.email = '';
        this.name = '';
        this.address = '';
        this.city = '';
        this.postal_code = '';
        this.country = '';
        this.type = 0;
        this.active = true;
        this.licence = '';
        this.idcompany = 0;
        this.instalations = []
        this.image = ''

    }
}